<template>
  <v-card>
    <v-app-bar absolute flat dense color="transparent" class="justify-end">
      <v-spacer />

      <v-menu bottom>
        <template #activator="{ on, attrs }">
          <v-btn class="files-list-item-show-more-actions" icon v-bind="attrs" v-on="on">
            <v-icon>{{ icons.mdiDotsVertical }}</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            class="files-list-item-download"
            @click="downloadFile(file.id, file.fileName)"
          >
            <v-list-item-title>
              <v-icon size="20" class="me-2">
                {{ icons.mdiDownloadOutline }}
              </v-icon>
              <span>Download</span>
            </v-list-item-title>
          </v-list-item>

          <v-list-item
            v-if="isParsable"
            class="files-list-item-parse"
            @click="parseFile(file.id, file.fileName)"
          >
            <v-list-item-title>
              <v-icon size="20" class="me-2">
                {{ icons.mdiCogPlayOutline }}
              </v-icon>
              <span>Parse</span>
            </v-list-item-title>
          </v-list-item>

          <v-list-item
            class="files-list-item-delete"
            @click="deleteFile(file.id, file.fileName)"
          >
            <v-list-item-title>
              <v-icon size="20" class="me-2">
                {{ icons.mdiDeleteOutline }}
              </v-icon>
              <span>Delete</span>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-card-title class="justify-center pa-12">
      <v-icon size="60">
        {{ resolveFileTypeVariant(file.fileMimeType) }}
      </v-icon>
    </v-card-title>

    <v-card-text style="background: #e7eae5">
      <div class="file-info pt-5">
        <p class="black--text files-list-item-name text-caption mb-2">{{ file.fileName }}</p>
        <p class="text-caption ma-0">
          <span>{{ bytesToKbytes(file.fileSize) }}KB</span>
          <v-icon small>{{ icons.mdiCircleSmall }}</v-icon>
          <span>{{ file.updatedAt | dayjs('YYYY-MM-DD') }}</span>
        </p>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { computed } from '@vue/composition-api';
import { mdiCircleSmall, mdiCogPlayOutline, mdiDeleteOutline, mdiDotsVertical, mdiDownloadOutline } from '@mdi/js';
import useChargebackFilesList from '@/views/chargebacks/chargeback-files/useChargebackFilesList';
import { ChargebackFileTypeEnum } from '@/enums/chargeback-file-type.enum';

export default {
  props: {
    file: {
      type: Object,
      required: true,
    },
  },
  methods: {
    bytesToKbytes(value) {
      return (value / 1024).toFixed(0);
    }
  },
  setup(props) {
    const { deleteFile, downloadFile, parseFile, resolveFileTypeVariant } = useChargebackFilesList();
    const isParsable = computed(() => props.file.fileType === ChargebackFileTypeEnum.VerifiRdr);

    return {
      resolveFileTypeVariant,
      deleteFile,
      downloadFile,
      parseFile,
      isParsable,
      icons: {
        mdiCircleSmall,
        mdiCogPlayOutline,
        mdiDeleteOutline,
        mdiDotsVertical,
        mdiDownloadOutline,
      },
    };
  }
};
</script>

<style lang="scss" scoped>
.files-list-item-name {
  height: 3.75rem;
  overflow: hidden;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  display: -webkit-box;
}
</style>
